export default class InterstitialTakeover {
  constructor(data) {
    if (data && data.fields && data.sys) {
      const {
        timerDuration,
        timerColour,
        headerLogoImage,
        dismissText,
        dismissColour,
        headerBackground,
        backgroundColours,
        backgroundGradientDirection,
        desktopBackgroundMedia,
        mobileBackgroundMedia,
        desktopBackgroundFocus,
        mobileBackgroundFocus,
        backgroundVideoSettings,
        contentVideoSettings,
        textContent,
        textContentMobile,
        textAlignment,
        verticalTextContentAlignment,
        textVariant,
        textContentBackground,
        imageAboveText,
        ctas,
        ctaLayout,
        legalText,
        desktopAsset,
        tabletAsset,
        mobileAsset,
        desktopVideoAsset,
        mobileVideoAsset,
        desktopAssetLayout,
        mobileAssetLayout,
        desktopAssetFocus,
        mobileAssetFocus,
        desktopLayout,
        mobileLayout,
        desktopTextContentWidth,
        mobileTextContentHeight,
        backgroundCtaUrl,
      } = data.fields;

      this.id = data.sys.id;
      this.timerDuration = timerDuration;
      this.timerColour = timerColour;
      this.headerLogoImage = headerLogoImage || null;
      this.dismissText = dismissText || '';
      this.dismissColour = dismissColour;
      this.headerBackground = headerBackground;
      this.backgroundColours = backgroundColours || [];
      this.backgroundGradientDirection = backgroundGradientDirection;
      this.desktopBackgroundMedia = desktopBackgroundMedia || null;
      this.mobileBackgroundMedia = mobileBackgroundMedia || null;
      this.desktopBackgroundFocus = desktopBackgroundFocus;
      this.mobileBackgroundFocus = mobileBackgroundFocus;
      this.backgroundVideoSettings = backgroundVideoSettings || [];
      this.contentVideoSettings = contentVideoSettings || [];
      this.textContentDesktop = textContent || null;
      this.textContentMobile = textContentMobile || null;
      this.textAlignment = textAlignment;
      this.verticalTextContentAlignment = verticalTextContentAlignment;
      this.textVariant = textVariant;
      this.textContentBackground = textContentBackground;
      this.imageAboveText = imageAboveText || null;
      this.ctas = ctas || [];
      this.ctaLayout = ctaLayout;
      this.legalText = legalText || null;
      this.desktopAsset = desktopAsset || null;
      this.tabletAsset = tabletAsset || null;
      this.mobileAsset = mobileAsset || null;
      this.desktopVideoAsset = desktopVideoAsset || null;
      this.mobileVideoAsset = mobileVideoAsset || null;
      this.desktopAssetLayout = desktopAssetLayout;
      this.mobileAssetLayout = mobileAssetLayout;
      this.desktopAssetFocus = desktopAssetFocus;
      this.mobileAssetFocus = mobileAssetFocus;
      this.desktopLayout = desktopLayout;
      this.mobileLayout = mobileLayout;
      this.desktopTextContentWidth = desktopTextContentWidth;
      this.mobileTextContentHeight = mobileTextContentHeight;
      this.backgroundCtaUrl = backgroundCtaUrl || null;
    }
  }
}
